import { ColumnDef, createColumnHelper } from '@tanstack/react-table'

import Currency from 'components/ui/Currency'

import { OrdersDetailsDataTypes } from 'types/orders-details-westfieldcorp'

export const useTablesOrdersDetails = ({
  dataTable,
}: {
  dataTable: OrdersDetailsDataTypes[]
}) => {
  const columnHelper = createColumnHelper<OrdersDetailsDataTypes>()
  const columns = [
    columnHelper.accessor('productName', {
      header: () => 'Product',
      cell: (info) => {
        const productName = info.getValue()

        return (
          <p className="flex flex-col uppercase">
            <span>{productName}</span>
          </p>
        )
      },
    }),
    columnHelper.accessor('cardNumberStart', {
      header: () => 'Start # / End #',
      cell: ({ row }) => {
        const start = row.original.cardNumberStart
        const end = row.original.cardNumberEnd

        return (
          <p className="flex flex-col">
            <span>
              {start ?? 'None'} <small>/</small> {end ?? 'None'}
            </span>
          </p>
        )
      },
    }),
    columnHelper.accessor('value', {
      header: () => 'Amount',
      cell: (info) => {
        const value = info.getValue()

        return (
          <p className="font-bold">
            {value.toLocaleString(undefined, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            })}
            <Currency countryCode={'NZ'} />
          </p>
        )
      },
    }),
    columnHelper.accessor('quantity', {
      header: () => 'Quantity',
      cell: (info) => {
        const quantity = info.getValue()

        return (
          <p className="flex flex-col">
            <span>{quantity}</span>
          </p>
        )
      },
    }),
  ] as ColumnDef<OrdersDetailsDataTypes>[]

  return {
    dataTable,
    columns,
  }
}
